webpackJsonp([256103571735664],{

/***/ 1605:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/jack-davey/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-jack-davey-da6a60cc9abbfe0b3d59.js